import { render, staticRenderFns } from "./PhoneNumberInput.vue?vue&type=template&id=c2281336&scoped=true&"
import script from "./PhoneNumberInput.vue?vue&type=script&lang=js&"
export * from "./PhoneNumberInput.vue?vue&type=script&lang=js&"
import style0 from "./PhoneNumberInput.vue?vue&type=style&index=0&id=c2281336&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c2281336",
  null
  
)

export default component.exports